import { t } from '@lingui/core/macro'
import Form from 'react-bootstrap/Form'

export default function DateRangePicker({ label, startDate, endDate, onStartDateChange, onEndDateChange }) {
  return (
    <>
      <Form.Label>{label}</Form.Label>
      <div className='d-flex gap-2'>
        <Form.Control
          type='date'
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          placeholder={t`Start date`}
        />
        <Form.Control
          type='date'
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          placeholder={t`End date`}
        />
      </div>
    </>
  )
}
